import { user, signIn, signOut, listen } from '../services/auth.service'
const avatar = 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Favatar.svg?alt=media&token=22cfc9de-bd76-4712-afe1-7725cb777659'
const logout = 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Flogout.svg?alt=media&token=2472b758-4539-4833-9d18-ddf5aa6a4deb'

export class LoginButton extends HTMLElement {
  constructor() {
    super();
    listen(() => this.connectedCallback())
  }

  login() {
    const dialog = document.createElement('login-dialog')
    document.body.appendChild(dialog)
  }

  handleEvent(event) {
    if (event.srcElement.classList.contains('e:login')) {
      this.login()
    }
    if (event.srcElement.classList.contains('e:logout')) {
      signOut()
    }
    if (event.srcElement.classList.contains('e:profile')) {
      console.log('profile')
    }
  }

  connectedCallback() {
    if (user.value) {
      this.innerHTML = `
        <div class="wrapper-buttons click">
          <figure class="avatar e:profile">
            <img class="e:profile" src="${user.value.photoURL || avatar}"/>
          </figure>
          <label class="e:profile">${user.value.displayName || user.value.email}</label>
          <figure class="avatar ml-auto e:logout">
            <img src="${logout}" class="e:logout"/>
          </figure>
        </div>
      `
    } else {
      this.innerHTML = `
        <div class="wrapper-buttons">
          <button class="btn button click e:login" type="button">LOGIN</button>
        </div>
      `
    }
    this.querySelectorAll('.click').forEach(node => node.addEventListener("click", this))
  }
}

window.customElements.define("login-button", LoginButton);
